import React from "react";

const UserSurveyorGoals = ({
  editState,
  updateAttr,
  userEditableAttr,
  surveyorGoalsEnabled
}) => {
  // Use the appropriate value based on edit state
  const currentValue = editState ? userEditableAttr.surveyor_goals_enabled : surveyorGoalsEnabled;

  return (
    <>
      {
        editState
          ? (
            <UserEditSurveyorGoals
              surveyorGoalsEnabled={currentValue}
              updateAttr={updateAttr} />
          )
          : (
            <UserShowSurveyorGoals surveyorGoalsEnabled={currentValue} />
          )
      }
    </>
  );
};

const UserShowSurveyorGoals = ({ surveyorGoalsEnabled }) => (
  <div className="row mb-3 align-items-center">
    <div className="col-3">Surveyor Goals Enabled?</div>
    <div className="col-9">
      <div className="custom-control custom-switch">
        <input
          checked={surveyorGoalsEnabled || false}
          className="custom-control-input"
          id="surveyor-goals-switch-view"
          type="checkbox"
          disabled
          readOnly />
        <label
          className="custom-control-label"
          htmlFor="surveyor-goals-switch-view" />
      </div>
      <small className="text-muted d-block mt-1">
        {surveyorGoalsEnabled ? "Goals tracking is enabled" : "Goals tracking is disabled"}
      </small>
    </div>
  </div>
);

const UserEditSurveyorGoals = ({ surveyorGoalsEnabled, updateAttr }) => {
  const handleToggle = e => {
    const newValue = e.target.checked;
    updateAttr({ surveyor_goals_enabled: newValue });
  };

  return (
    <div className="row mb-3 align-items-center">
      <div className="col-3">Surveyor Goals Enabled?</div>
      <div className="col-9">
        <div className="custom-control custom-switch">
          <input
            checked={surveyorGoalsEnabled || false}
            className="custom-control-input"
            id="surveyor-goals-switch-edit"
            type="checkbox"
            onChange={handleToggle} />
          <label
            className="custom-control-label"
            htmlFor="surveyor-goals-switch-edit" />
        </div>
        <small className="text-muted d-block mt-1">
          {surveyorGoalsEnabled ? "Goals tracking is enabled" : "Goals tracking is disabled"}
        </small>
      </div>
    </div>
  );
};

export default UserSurveyorGoals;